// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/css/reset.css'
import '../public/swiper/swiper-bundle.min.css';
import Menus from '@/components/nav/menus.vue'
import Footer from '@/components/footer/web_footer'
import PhoneNav from '@/components/phone/nav'
import PhoneFooter from '@/components/footer/phone_footer'
import VueScroller from 'vue-scroller'
import axios from 'axios'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
axios.defaults.baseURL = 'http://sys.hljsyxjs.net'
// axios.defaults.baseURL = 'http://sys.jxxfjxh.cn'
// axios.defaults.baseURL = 'http://sys.ffxzxy.com'
// axios.defaults.baseURL = 'http://sys.fj.com'
// try_files $uri $uri/ /index.html;
Vue.use(VueScroller)
Vue.http = Vue.prototype.$http = axios
Vue.prototype.$layer = layer(Vue);
Vue.config.productionTip = false
Vue.component("v-menu", Menus);
Vue.component("v-footer", Footer);
Vue.component("v-phoneFoot", PhoneFooter);
Vue.component("v-nav",PhoneNav)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js